import { type TgSession } from '../../../../redux/types/TgSessionsTypes';

export const statusInfo = (session: TgSession): { label: string; tone: 'ok' | 'warn' | 'bad' | 'muted' } => {
  if (session.status === 'ACTIVE') {
    return session.is_active ? { label: 'Работает', tone: 'ok' } : { label: 'Отключён', tone: 'muted' };
  }
  switch (session.status) {
    case 'CODE_SENT':
      return { label: 'Ожидает код', tone: 'warn' };
    case 'QR_PENDING':
      return { label: 'Ожидает сканирования QR', tone: 'warn' };
    case 'PASSWORD_REQUIRED':
      return { label: 'Нужен пароль 2FA', tone: 'warn' };
    case 'DEAD':
      return { label: 'Сессия слетела', tone: 'bad' };
    case 'DISABLED':
      return { label: 'Отключён', tone: 'muted' };
    default:
      return { label: 'Не подключён', tone: 'muted' };
  }
};

export const outcomeLabel = (result: string): string => {
  const labels: Record<string, string> = {
    MATCHED: 'Заявка подтверждена',
    NO_CANDIDATE: 'Нет подходящей заявки',
    AMBIGUOUS: 'Несколько подходящих заявок',
    NOT_PARSED: 'Не платёжное уведомление',
    ALREADY_APPROVED: 'Заявка уже подтверждена',
    NO_TRADER: 'Не привязан трейдер',
    ERROR: 'Ошибка подтверждения',
  };
  return labels[result] || result;
};

export const formatDate = (value: string | null): string => (value ? new Date(value).toLocaleString('ru-RU') : '—');

export const maskCard = (accountNumber: string): string => {
  const digits = accountNumber.replace(/\D/g, '');
  return digits.length >= 4 ? `···${digits.slice(-4)}` : accountNumber;
};

export const getErrorText = (error: unknown, fallback: string): string => {
  const data = (error as { data?: unknown })?.data;
  if (!data) return fallback;
  if (typeof data === 'string') return data;
  if (typeof data === 'object') {
    const record = data as Record<string, unknown>;
    if (typeof record.detail === 'string') return record.detail;
    const first = Object.values(record)[0];
    if (Array.isArray(first) && typeof first[0] === 'string') return first[0];
    if (typeof first === 'string') return first;
  }
  return fallback;
};
